import { Toast } from "vant";
// 打包前看readme文件
export const mixins = {
  data() {
    return {
      urlList: [
        {
          time: 0,
          name: "91porn",
          url: "https://d11mj6p2thi2vw.cloudfront.net",
        },
        {
          time: 0,
          name: "逼哩逼哩",
          url: "https://d2abfw20zg31a.cloudfront.net",
        },
        {
          time: 0,
          name: "海角乱伦",
          url: "https://d1t1unolaftanx.cloudfront.net",
          webUrl: "https://doyj68zud8dgm.cloudfront.net",
        },
        // {
        //   time: 0,
        //   name: "91原创",
        //   url: "https://d24huswlob3me8.cloudfront.net",
        // },
        {
          time: 0,
          name: "X视频",
          url: "https://d3vxk2z1tattao.cloudfront.net",
        },
        {
          time: 0,
          name: "好色",
          url: "https://d1f1wgvqrzh80g.cloudfront.net",
          webUrl: "https://d39cmeitkp3imu.cloudfront.net",
        },
        {
          time: 0,
          name: "快手视频",
          url: "https://d3av7ubft4r35p.cloudfront.net",
        },
        {
          time: 0,
          name: "91国产",
          url: "https://d3hazbgk7dtwpj.cloudfront.net",
          webUrl: "https://da8ttmrfqqhqf.cloudfront.net",
        },
        {
          time: 0,
          name: "91暗网",
          url: "https://d1h0kcl57yrnyf.cloudfront.net",
          webUrl: "https://dh0n7f6bcnjxj.cloudfront.net",
        },

        // {
        //   time: 0,
        //   name: "Pomhub专业版",
        //   url: "https://d33dshu4o4qo3d.cloudfront.net",
        // },
        {
          time: 0,
          name: "快手视频",
          url: "https://d3av7ubft4r35p.cloudfront.net",
        },
        {
          time: 0,
          name: "爆奶视频",
          url: "https://d176i026eng5sy.cloudfront.net",
        },
        // { time: 0, name: "妻友", url: "https://dlk8pgalog34q.cloudfront.net" },
        {
          time: 0,
          name: "91原创",
          url: "https://d24huswlob3me8.cloudfront.net/",
        },
        {
          time: 0,
          name: "69精选",
          url: "https://d2edxhak7g6q3q.cloudfront.net",
        },
        { time: 0, name: "XV暗网", url: "https://d79yza78u30c.cloudfront.net" },
        {
          time: 0,
          name: "91国产",
          url: "https://d3hazbgk7dtwpj.cloudfront.net",
        },
      ],
      ping: 1,
      timer: null,
      showImg: true,
      addressUrl: "cao.gg",
    };
  },
  mounted() {
    this.addressUrl = window.location.host;
    this.$nextTick(() => {
      this.init();
    });
  },
  methods: {
    init() {
      this.timer = setInterval(() => {
        this.ping++;
      }, 100);
    },
    autoTest(item, index) {
      if (this.ping <= 10) {
        item.time = this.ping * 10;
      } else {
        item.time = this.ping * 100;
      }
      if (index == this.urlList.length - 1) {
        clearInterval(this.timer);
      }
    },
    jumpUrl(url) {
      const routeDc = this.$route.query.dc;
      if (routeDc) {
        window.open(url + "?dc=" + routeDc);
      } else {
        const dc = process.env.VUE_APP_WEB_DC || "lqz01";
        window.open(url + "?dc=" + dc);
      }
    },
    reset() {
      this.urlList = this.urlList.map((item) => {
        item.time = 0;
        return item;
      });
      this.showImg = false;
      this.$nextTick(() => {
        this.showImg = true;
      });
      this.ping = 1;
      this.init();
    },
    doCopy() {
      let req = this.addressUrl;
      this.$copyText(req).then(
        () => {
          Toast("复制成功");
        },
        () => {
          Toast("复制失败");
        },
      );
    },
  },
};
